import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Big3Common } from '../../../js/IncludeManager'

/* 개발담당:양유빈
 * 화면기능: 상품관리의 상품 리스트 화면
 * 세부설명:
*/

export class GoodsList extends Component {
    static displayName = GoodsList.name;

    constructor(props) {
        super(props);
        this.state = {
            TotalCount: 0,
            GoodsListModel:[],
            Goods_No: null,
            Search_Text: "",
            Search_Type:"reg_dt"
        };
        this.Page_Number = 1;
        this.Page_Size = Big3Common.WebConfig.Page_Size;

        this.handleComponent_Click = this.handleComponent_Click.bind(this);
        this.handleSearch_Change = this.handleSearch_Change.bind(this);
        this.handleAdd_Click = this.handleAdd_Click.bind(this);
    }
    //초기화
    async componentDidMount() {
        if (this.props.ContentState !== null) {
            await Big3Common.setContentStateBind(this);
        }
        this.CallGoodsList();
    }
    //검색조건 이벤트
    async handleSearch_Change(event) {
        //페이지 초기화
        this.Page_Number = 1
        let tagId = event.target.id;
        if (tagId === "searchCombo") {
            let ComboVal = event.target.value;
            this.state.Search_Type = ComboVal;
            await this.CallGoodsList();
        }
        else if (tagId === "searchText") {
            let textVal = event.target.value;
            this.state.Search_Text = textVal;
            await this.CallGoodsList();
        }
        event.preventDefault();
    }
    //사진을 클릭 하고 상세이동
    handleComponent_Click(event, ComName, Goods_No) {
        //setState를 사용하면 다음 로직에 값이 할당되지 않음. 
        //stateCopy에 값을 할당하여 전달 
        let StateCopy = Big3Common.WebStorage.StateStorage(this.state, ["GoodsListModel","TotalCount"]);
        StateCopy.Goods_No = Goods_No;
        this.props.RenderComponent(ComName, StateCopy);
        event.preventDefault();
    }
       
    async CallGoodsList(isAppend) {
        try {
            Big3Common.Util.LoadingOn();
            const Model = {
                Search_Text: this.state.Search_Text,
                Search_Type: this.state.Search_Type,
                Page_Number: this.Page_Number,
                Page_Size: this.Page_Size
            }
            let Data = await Big3Common.Post(`api/Goods/GoodsMgr/GetGoodsList`, Model, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const TotalCount = (this.Page_Number * this.Page_Size);
                let DataList = JSON.parse(Data.dataTable);
                if (isAppend) {
                    const GoodsListPush = this.state.GoodsListModel;
                    DataList.map(list => GoodsListPush.push(list));
                    this.setState({ GoodsListModel: GoodsListPush, TotalCount: TotalCount });
                }
                else {
                    this.setState({ GoodsListModel: DataList, TotalCount: TotalCount });
                }
                
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("CallGoodsList: ", e)
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
        return false;
    }
    handleAdd_Click() {
        this.Page_Number++;
        this.CallGoodsList(true);
    }
    //상품정렬
    SoldOutrender(soldout_yn) {
        if (soldout_yn === "Y") {
            return (<div className="sold_out_box"><div className="sold_out">SOLD OUT</div></div>);
        }
        else {
            return ("");
        }
    }
    //상품 리스트 랜더링
    GoodsImagerender() {
        let GoodsListModel = this.state.GoodsListModel;
        let VirtualRoot = Big3Common.WebConfig.GoodsImageVirtualPath();
        return (
            <div className="goods_list row row-cols-3">
                {GoodsListModel.map(list =>
                    <div className="col" key={list.goods_no}>
                        <div className="goods_img pointer"
                            style={{ backgroundImage: `url(${VirtualRoot}${list.img_220})` }}
                            onClick={(e) => { this.handleComponent_Click(e, 'GoodsDtl', list.goods_no); }}
                        >{this.SoldOutrender(list.soldout_yn)}</div>
                        <div className="goods_title">{list.goods_nm}</div>
                        <div className="goods_price">{list.strqst_yn === "Y" ? "매장문의" : `${Big3Common.Util.Money(list.goods_price)}원` }</div>
                        <div className="goods_views">조회수 {list.view_cnt}건</div>
                    </div>
                )}

                <div className="more_button">
                    {
                        this.state.TotalCount === this.state.GoodsListModel.length && this.state.TotalCount > 0 ?
                            <button type="button" className="btn_v btn_inactive" onClick={this.handleAdd_Click}>더보기</button>
                            : ""
                    }
                </div>
            </div>
        )
    }
    render() {
        let GoodsImage = this.GoodsImagerender();
        return (
            <div>
                <div className="tap_box tap_box_v2">
                    <div className="n_tap"><div className="alert_tap"><Link to="/Goods/RegisterMgr/Index">상품등록</Link></div></div>
                    <div className="n_tap"><div className="alert_tap tap_on">상품관리</div></div>
                </div>
                <div className="goods_wrap">
                    <div className="search_box">
                        <div className="search_input_box">
                            <input type="text"
                                placeholder="상품명을 입력해주세요."
                                className="form-control"
                                id="searchText"
                                defaultValue={this.state.Search_Text}
                                onBlur={this.handleSearch_Change} />
                            <div className="search_btn pointer" onClick={this.handleSearch_Change }></div>
                        </div>
                        <div className="order_select_box">
                            <select onChange={this.handleSearch_Change} id="searchCombo" value={this.state.Search_Type} >
                                <option value="reg_dt">최근순</option>
                                <option value="sale_cnt">판매량 많은순</option>
                                <option value="view_cnt">조회수 많은순</option>
                                <option value="soldout_yn">품절 상품</option>
                            </select>
                            <div className="select_btn"></div>
                        </div>
                    </div>
                    {GoodsImage }
                </div>
            </div>
        );
    }
}
